import { mq, StyleSheet, UnistylesRuntime } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors }) => ({
  container: {
    flexDirection: "row",
    gap: spacing(1),
    justifyContent: "space-around",
    backgroundColor: colors.backgroundDefault,
    bottom: 0,
    left: 0,
    right: 0,
    _web: {
      position: "fixed",
    },
  },
  tab: {
    flex: 1,
  },
  tabInner: {
    padding: spacing(3),
    gap: spacing(1),
    justifyContent: "center",
    alignItems: "center",
    flexDirection: {
      [mq.only.width(undefined, "lg")]: "column",
      [mq.only.width("lg")]: "column",
    },
  },
  tabIcon: {
    width: spacing(6),
    height: spacing(6),
    color: colors.foregroundDefault,
  },
  tabIconActive: {
    color: colors.foregroundDefault,
  },
  tabLabel: ({ isActive }: { isActive: boolean }) => ({
    color: isActive ? colors.foregroundDefault : colors.foregroundDefaultMuted,
  }),
}));

const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  icon: [
    { width: initialTheme.spacing(6), height: initialTheme.spacing(6) }, // for 1:1
  ],
};

export default stylesheet;
